module.exports = __webpack_public_path__ + "static/img/tree_update.62f6031.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/tree_update.png
// module id = +jiQ
// module chunks = 1